import { useEffect, useState } from 'react';
import { Flex } from '@/app/ui/atoms';
import { BarData } from '@/app/ui/organisms/CustomBarChart/CustomBarChart';
import { ButtonsNavBar } from '@/app/ui/molecules';
import CustomLineChart, { LineChartData } from '@/app/ui/organisms/CustomLineChart/CustomLineChart';
import { translate } from '@/app/i18n';

const RevenueMonthly = () => {
  const [earningsData, setEarningsData] = useState<LineChartData>({});
  const [activeTab, setActiveTab] = useState<string>(translate('EARNINGS.ALL'));

  // Predefined values for each tab
  const predefinedValues = {
    [translate('EARNINGS.ALL')]: [10, 12, 8, 15, 16],
    [translate('DIGITAL_DISTRIBUTION.DIGITAL_DISTRIBUTION')]: [5, 5, 4, 7, 10],
    [translate('EARNINGS.PUBLISHING')]: [5, 7, 4, 8, 6],
  };

  useEffect(() => {
    // Get current date and last 5 months
    const currentDate = new Date();
    const months = [];
    const currentYear = currentDate.getFullYear();

    for (let i = 0; i < 5; i += 1) {
      const month = new Date(currentYear, currentDate.getMonth() - i, 1);
      months.push({
        year: month.getFullYear(),
        month: month.toLocaleString('default', { month: 'short' }).toLowerCase(),
      });
    }
    months.reverse();

    // Generate data for each year
    const earningsBarData: LineChartData = {};
    const values = predefinedValues[activeTab] || predefinedValues[translate('EARNINGS.ALL')];

    // Generate data for current year
    const currentYearData: BarData[] = months
      .filter((m) => m.year === currentYear)
      .map((m, index) => ({
        x: m.month,
        y: values[index] || 0,
      }));

    if (currentYearData.length > 0) {
      earningsBarData[currentYear.toString()] = currentYearData;
    }

    // Generate data for previous year if needed
    const previousYear = currentYear - 1;
    const previousYearData: BarData[] = months
      .filter((m) => m.year === previousYear)
      .map((m, index) => ({
        x: m.month,
        y: values[index] || 0,
      }));

    if (previousYearData.length > 0) {
      earningsBarData[previousYear.toString()] = previousYearData;
    }

    setEarningsData(earningsBarData);
  }, [activeTab]);

  function changeTab(tab: string) {
    setActiveTab(tab);
  }

  return (
    <Flex.Container flexDirection="column" gap="2.5rem">
      <ButtonsNavBar
        defaultTab={translate('EARNINGS.ALL')}
        tabs={[
          translate('EARNINGS.ALL'),
          translate('DIGITAL_DISTRIBUTION.DIGITAL_DISTRIBUTION'),
          translate('EARNINGS.PUBLISHING'),
        ]}
        onSelectTab={(tab) => changeTab(tab)}
      />
      <CustomLineChart yaxis="Revenue" data={earningsData} />
    </Flex.Container>
  );
};

export default RevenueMonthly;
